

















import { Component, Vue, Prop } from 'vue-property-decorator'
import { Track } from '@/classes/track'
import { IRule } from '@/helpers/filter-rules'

@Component({
  components: {
    ProgressLoader: require('@/components/ProgressLoader').default,
    PreviewItem: require('./PreviewItem').default
  }
})
export default class Preview extends Vue {
  @Prop()
  tracks: Track[]

  @Prop()
  rules: IRule[]

  @Prop()
  loading: boolean

  get tracksFirst(): Track[] {
    return this.tracks.slice(0, 10)
  }
}
